class ModalSlide extends HTMLElement {
  constructor(params) {
    super();
    if(this.querySelector('template')) {
      this.template = this.querySelector('template').cloneNode(true).content
      this.swiperContents = document.createElement("div");
      this.swiperContents.classList.add("swiperContents");
      this._render();
    }
  }

  static get observedAttributes() {
    return [
      "slide-handle",
      "slide-title",
      "slide-theme",
    ];
  }

  closeModal() {
    const modal = document.querySelector('x-modal');
    modal.dispatchEvent(new Event("close-modal"));
    // const modal = new Modal
    // modal.closeCollectionModal();
  }

  updatePrice() {
    const countryCode = document.querySelector(".variant-select").getAttribute("data-country");
    const currencyCode = document.querySelector(".variant-select").getAttribute("data-currency");  
    const price = document.querySelector(".variant-select option:checked").getAttribute("data-variant-price").replace(',','') * 100;
    const comparePrice = document.querySelector(".variant-select option:checked").getAttribute("data-variant-compare-price").replace(',','') * 100;
    let selectedVariants = $(
      ".addOn"
      );
      var selectedFormData = $.map(selectedVariants, function (obj) { return obj.getAttribute('data-price').replace(',',''); });
      var priceWithAddOns = parseInt(price,10) + (selectedFormData.reduce((partialSum, a) => parseFloat(partialSum,10) + parseFloat(a,10), 0) * 100);
      var comparePriceWithAddOns = parseInt(comparePrice,10) + (selectedFormData.reduce((partialSum, a) => parseFloat(partialSum,10) + parseFloat(a,10), 0) * 100);
      var currency = new Intl.NumberFormat("en-" + countryCode, { style: "currency", currency: currencyCode, minimumFractionDigits: 0, maximumFractionDigits: 0 });

      $('.configuratorPrice, .OrderSummaryPrice .configuratorPrice').html(currency.format(priceWithAddOns/100));
      if (comparePrice > 0.0) {
        $('.configuratorComparePrice, .OrderSummaryPrice .configuratorComparePrice').html(currency.format(comparePriceWithAddOns/100));
      } else {
        $('.configuratorComparePrice, .OrderSummaryPrice .configuratorComparePrice').html('');
      }
  }

  isMetric() {
    return !document.body.getAttribute("data-imperial")
  }

  unitInKmH(value) {
    const conversion = this.isMetric() ? 1 : 2.54;
    if (value) {
      return Math.round(value / conversion);
    }
  }

 round(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}

  unitInCms(value, decimalPlaces = 0) {
    const conversion = this.isMetric() ? 1 : 0.0393701;
    if (value) {
      return this.round((value / conversion), decimalPlaces);
    }
  }

  unitsMMSquaredToInchesSquared(value, decimalPlaces = 0) {
    const conversion = this.isMetric() ? 1 : 645.2;
    if (value) {
      return this.round((value / conversion), decimalPlaces);
    }
  }

  unitsMMToInches(value, decimalPlaces = 0) {
    const conversion = this.isMetric() ? 1 : 25.4;
    if (value) {
      return this.round((value / conversion), decimalPlaces);
    }
  }

  unitsCMToInches(value, decimalPlaces = 0) {
    const conversion = this.isMetric() ? 1 : 2.54;
    if (value) {
      return this.round((value / conversion), decimalPlaces);
    }
  }

  convertUnitValue(value, unit) {
    var _value = value.innerText
    var _unit = unit.innerText
    if(this.isMetric()){
      // Do nothing
    } else {
      switch(_unit) {
        case 'cm':
          _value = this.unitsCMToInches(_value)
          break;
        case 'cm²':
          _value = this.unitsMMSquaredToInchesSquared(_value, 1)
          break;
        case 'mm':
            _value = this.unitsMMToInches(_value)
            break;
      }
    }
    value.innerText = _value
    return value
  }

  convertUnitName(unit) {
    var _unit = unit.innerText
    if(this.isMetric()){
      // Do nothing
    } else {
      switch(_unit) {
        case 'cm':
          _unit = 'in'
          break;
        case 'cm²':
          _unit = 'in²'
          break;
        case 'mm':
            _unit = 'in'
            break;
      }
    }
    unit.innerText = _unit
    return unit
  }

  get slideImageSrc() {
    return this.template.querySelector(".slide-image").getAttribute("src");
  }

  get slideDescription() {
    const placeholder = document.createElement('span')
    return this.template.querySelector(".slide-description") ? this.template.querySelector(".slide-description").innerHTML : placeholder;
  }

  get slideHandle() {
    return this.getAttribute("slide-handle");
  }

  get slideTitle() {
    const text = this.template.querySelector('h3').innerText.split(' - ').reverse()[0]
    const hTag = document.createElement('h3')
    hTag.classList.add('h1')
    hTag.innerText = text
    return hTag;
  }

  get slideType() {
    return this.getAttribute("slide-type");
  }

  get slideTheme() {
    return this.getAttribute("slide-theme");
  }

   featureImage() {
    const img_path = this.slideImageSrc ? this.slideImageSrc : false;
    if((this.slideType == 'collection') || (this.slideHandle.includes('propulsion')) || (this.slideHandle.includes('materials'))) {
      const img_holder = document.createElement("div");
      img_holder.classList.add("modal-image");
      img_holder.setAttribute('style', `background: url(${img_path}) no-repeat center center; background-size: cover;`)
      img_holder.setAttribute('data-src', img_path);
      return img_holder
    } else {
      const img_holder = document.createElement("img");
      img_holder.setAttribute('src', img_path);
      img_holder.setAttribute('data-src', img_path);
      img_holder.classList.add("modal-image");
      return img_holder
    }
  }

  connectedCallback() {

  }

  generateContents() {
    this.imageSection = document.createElement("div");
    this.imageSection.classList.add("swiperImage");
    this.swiperDescription = document.createElement("div");
    this.contents();
  }

  secondaryImage() {
    const secondImg = this.template.querySelector(".modal-image");
    if(secondImg) {
      this.swiperDescription.append(secondImg)
    }

  }

  collectionView() {
    this.swiperDescription.innerHTML = ''
    const swiperDescription = this.swiperDescription;
    const swiperFade = document.createElement("div");
    swiperFade.classList.add("swiperFade");
    swiperFade.classList.add(this.slideTheme);

    this.swiperContents.appendChild(swiperFade);
    this.swiperContents.classList.add("swiperContents");
    this.swiperDescription.classList.add("swiperDescription");
    this.swiperDescription.innerHTML = this.slideDescription;
    this.swiperContents.appendChild(swiperDescription);
  }

  productDataView() {
    const features = ["perfect-for", "riders", "boards"];
    this.swiperContents.appendChild(this.slideTitle)
    const swiperDescription = this.swiperDescription;
    const swiperFeatures = document.createElement("div");
    swiperFeatures.classList.add("swiperFeatures");
    features.forEach((element) => {
      const featureHolder = document.createElement("strong");
      const featureContent = this.template.querySelector(`.features .${element}`) && this.template.querySelector(`.features .${element}`).innerText;
      featureHolder.classList.add("feature");
      featureHolder.innerHTML = featureContent;
      swiperFeatures.appendChild(featureHolder);
    });
    this.swiperContents.appendChild(swiperFeatures);
    this.swiperDescription.classList.add("swiperDescription");
    this.swiperDescription.innerHTML = this.slideDescription;
    this.swiperContents.appendChild(swiperDescription);
    this.generateTable()
  }

  productBuyView() {
    const variantForm = this.template.querySelector('.SlideVariants');
    const variantFormSelect = variantForm.querySelector('.SlideVariantsSelector');
    const productType = variantForm.getAttribute('data-product-type');
    const variantFormSelection = variantForm.querySelector('.SlideVariantsSelector select');
    const icon = document.getElementById('down-arrow').cloneNode(true);
    variantFormSelect.appendChild(icon);
    variantFormSelection.addEventListener('change', (e) => {
      console.log(e.target.selectedOptions[0])
      const variant = e.target.selectedOptions[0];
      const variantPrice = variant.getAttribute('data-variant-price');
      const variantImage = variant.getAttribute('data-product-image');
      var currency = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
      
      this.querySelector('.variant_price').innerHTML = currency.format(variantPrice.replace(',',''));
      if(this.querySelector('.swiperImage img')) {
        this.querySelector('.swiperImage .modal-image').src = variantImage;
      }
      if(this.querySelector('.swiperImage div')) {
        this.querySelector('.swiperImage .modal-image').setAttribute('style', `background: url(${variantImage}) no-repeat center center; background-size: cover;`)
      }
            // variantImage.classList.add('img');	
     });
    const productTitle = this.slideTitle;
    const swiperDescription = this.swiperDescription;
    const buyButton = document.createElement('span');
    const pricingSection = document.createElement('div');
    const priceAmount = document.createElement('span');
    const taxMessage = document.createElement('span');
    this.swiperContents.classList.add("swiperContents");
    swiperDescription.classList.add("swiperDescription");
    swiperDescription.innerHTML = this.slideDescription;
    this.swiperContents.append(productTitle, swiperDescription);
    taxMessage.innerHTML = ' ';
    priceAmount.innerHTML = ' ';
    buyButton.innerHTML = 'Add to order';

    buyButton.addEventListener("click", (e) => {
      const EnhanceSummary = document.getElementById('summaryEnhancements');
      variantForm.classList.add('added');
      const addedMsg = this.closest('learn-more').querySelector('button').getAttribute('data-added-msg');
      const added = document.createElement('div');
      const addedCheck = document.createElement('div');
      addedCheck.classList.add('added-check');
      const checkMark = document.getElementById('added-check').cloneNode(true);
      addedCheck.appendChild(checkMark);
      added.innerText = `${productType} added`
      buyButton.innerHTML = 'Added...';
      const learnMore = this.closest('learn-more').querySelector('button')
      const og = learnMore;
      learnMore.appendChild = addedCheck;
      learnMore.appendChild = added;

      variantForm.querySelectorAll('select option:checked').forEach((element, i) => {
        const SummaryBlock = document.createElement('div');
        const SummaryInput = document.createElement('input');
        SummaryInput.value = element.value;
        SummaryBlock.classList.add('addOn');
        SummaryInput.classList.add('enhancement');
        SummaryBlock.appendChild(SummaryInput);
        const SummaryImgHolder = document.createElement('div');
        const SummaryImg = document.createElement('img');
        const SummaryDescription = document.createElement('div');
        const variantTitle = element.getAttribute('data-variant-title');
        const productTitle = element.getAttribute('data-product-title');
        const variantPrice = element.getAttribute('data-variant-price');
        // const variantSku = element.getAttribute('data-sku');
        const img = element.getAttribute('data-product-image');
        const SummaryTitle = document.createElement('h5');
        const SummaryVariantTitle = document.createElement('p');
        SummaryDescription.classList.add('summary-text');
        SummaryBlock.setAttribute('data-price', variantPrice);
        SummaryTitle.innerText = productTitle;
        SummaryVariantTitle.innerText = variantTitle;
        SummaryImg.src = img;
        SummaryImgHolder.classList.add('img');
        SummaryImgHolder.appendChild(SummaryImg);
        const RemoveSpan = document.createElement('span');
        RemoveSpan.classList.add('remove','Link','Link--underline','Link--underlineShort');
        RemoveSpan.innerText = 'Remove';
        SummaryDescription.append(SummaryTitle, SummaryVariantTitle, RemoveSpan);
        SummaryBlock.classList.add('SummaryBlock');
        SummaryBlock.append(SummaryImgHolder, SummaryDescription);
        EnhanceSummary.appendChild(SummaryBlock);
        RemoveSpan.addEventListener('click', (e) => {
          SummaryBlock.remove();
          variantForm.classList.remove('added');
          buyButton.innerHTML = 'Add to order';
          learnMore.innerHTML = og.innerHTML;
          this.updatePrice();
        });
      });
        this.updatePrice();
        this.closeModal();
    });
    pricingSection.appendChild(priceAmount);
    pricingSection.appendChild(taxMessage);
    buyButton.classList.add('Button','Button--primary');
    this.swiperContents.appendChild(variantForm);
    this.swiperContents.appendChild(pricingSection);
    this.swiperContents.appendChild(buyButton);

  }

  generateTable() {
    const data = this.template.querySelectorAll('ul.data-table>dl')
    const dataList = this.template.querySelector('ul.data-table')
    if(data && dataList){
    const tableCols = dataList.getAttribute('cols') || 1
    const table = document.createElement('table')
    table.classList.add(`cols-${tableCols}`)
    var colsArray = Array.prototype.slice.call(data);
    var arrays = [], size = tableCols ;
    while (colsArray.length > 0)
    arrays.push(colsArray.splice(0, size));
    arrays.forEach((element, i) => {
      const row = document.createElement('tr')
      if(!(i% 2 == 0)) {
        row.classList.add('even')
      } else {
        row.classList.add('odd')
      }
      element.forEach((col, i) => {
        const key = document.createElement('td')
        const value = document.createElement('td')
        value.classList.add('field_value')
        if((i% 2 == 0)) {
          key.classList.add('key')
        } else {
          value.classList.add('last')
        }
        key.innerHTML = col.querySelector('dt').innerHTML
        value.innerHTML = col.querySelector('dd').innerHTML
        const _value = value.querySelector('.value')
        const _unit = value.querySelector('.unit')
        if(_unit) {
          value.appendChild(this.convertUnitValue(_value, _unit))
          value.appendChild(this.convertUnitName(_unit))
        } else {
          value.appendChild(_value)
        }
        row.appendChild(key)
        row.appendChild(value)
      })

      table.appendChild(row)
    })
    this.swiperContents.appendChild(table);
    }
  }

  rangeFinder(increment) {
    var left = 0
    switch(increment) {
      case 15:
        left = 0
        break;
      case 15:
          left = 0
          break;
      case 20:
        left = 10
        break;
      case 25:
        left = 23
        break;
      case 30:
        left = 37
        break;
      case 35:
        left = 50
        break;
      case 40:
        left = 63
        break;
      case 45:
        left = 77
        break;
      case 50:
        left = 90
        break;
      default:
        left = 0
    }
    return left
  }

  generateSpeedRange() {
    const data = this.template.querySelector('.speed-table')
    if(data) {
    const meterContainer = document.createElement('div')
    const meter = document.createElement('div')
    meter.classList.add('meter')
    meterContainer.classList.add('meter-container')
    const meterContainerHeader = document.createElement('div')
    meterContainerHeader.classList.add('meter-container-header')
    const heading = document.createElement('span')
    const units = document.createElement('span')
    units.classList.add('units')
    units.innerHTML = this.isMetric() ? 'Kmh' : 'Mph'
    heading.innerText = 'Speed Range'
    const speedRange = [15,20,25,30,35,40,45,50]
    const meterRange = document.createElement('div')
    meterRange.classList.add('meter-range')
    speedRange.forEach((element, i) => {
      const meterRangeItem = document.createElement('div')
      meterRangeItem.classList.add('meter-range-item')
      meterRangeItem.innerHTML = this.unitInKmH(element)
      meterRange.appendChild(meterRangeItem)
    })
    const optimumSpeedRange = parseInt(data.querySelector('.sr-opt').innerText)
    const maxSpeedRange = [parseInt(data.querySelector('.sr-low').innerText),parseInt(data.querySelector('.sr-high').innerText)]
    const optimumSpeedRangeItem = document.createElement('div')
    optimumSpeedRangeItem.classList.add('meter-range-optimum')
    const maxSpeedRangeItem = document.createElement('div')
    maxSpeedRangeItem.style.left = `${this.rangeFinder(maxSpeedRange[0])}%`
    maxSpeedRangeItem.style.right = `${86 - this.rangeFinder(maxSpeedRange[1])}%`
    optimumSpeedRangeItem.style.left = `${this.rangeFinder(optimumSpeedRange)}%`
    maxSpeedRangeItem.classList.add('meter-range-max')
    meter.append(optimumSpeedRangeItem, maxSpeedRangeItem)
    meterContainerHeader.append(heading, units)
    meterContainer.append(meterContainerHeader, meterRange, meter)
    this.swiperContents.appendChild(meterContainer)
    }
  }

  generateImageSection() {
    this.imageSection.innerHTML = this.featureImage().outerHTML;
  }

  contents() {
    switch (this.slideType) {
      case "collection":
        this.collectionView();
        break;
      case "product-buy":
        this.productBuyView();
        break;
      case "product-data":
        this.productDataView();
        break;
    }
  }

  _render() {
    this.generateContents();
    const slide = this;
    slide.innerHTML = '';
    const cover = document.createElement("div");
    cover.classList.add("cover");
    const slideClasses = ['swiper-slide-content', this.slideTheme, this.slideType]
    slide.classList.add(...slideClasses);
    slide.appendChild(cover);
    this.generateImageSection();
    this.generateSpeedRange()
    const fadeSpace = document.createElement("div");
    fadeSpace.classList.add("fade-space");
    // Comments
    // if(this.slideType === 'collection') {
    //   const swiperFade2 = document.createElement("div");
    //   const fadeClasses = ['swiperFade', this.slideTheme]
    //   swiperFade2.classList.add(...fadeClasses)
    //   this.imageSection.appendChild(swiperFade2);
    // }
    slide.append(this.imageSection, this.swiperContents);
  }
}

window.customElements.define("modal-slide", ModalSlide);